import React, { Component } from 'react'
import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  Grid,
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  Paper,
  InputAdornment,
  Input,
} from '@material-ui/core'

import { AgGridReact } from 'ag-grid-react'
import { connect } from 'react-redux'
import { EditableReactSelect } from '../common/EditableComponents'
import {
  addLocationMasterProduct,
  searchAvailableMasterProducts,
} from '../../actions/masterCatalog'
import SearchIcon from '@material-ui/icons/Search'
import { checkAccessToShop } from '../../utils/api'

const perPage = 20
let timeout

class ModalAddLocation extends Component {
  constructor(props) {
    super(props)

    this.state = {
      gridApi: null,
      selectedStore: [],
      stores: [],
      hasError: {
        isVisible: false,
        message: '',
      },
      selectedRows: [],
      step: 1,
      tableIsVisible: true,
      term: '',
    }
  }

  componentDidMount() {
    this.getShops()
  }

  componentDidUpdate(prevProps, prevState, snapshot) {
    const { term } = this.state
    if (snapshot) {
      this.getMasterProducts(term)
    }
  }

  getSnapshotBeforeUpdate(prevProps, prevState) {
    return this.state.gridApi != prevState.gridApi
  }

  getShops = () => {
    const { shopReducer } = this.props
    const shopList = shopReducer.shopsList
      ? (shopReducer.shopsList.values || []).map((shop) => {
          var shopEnabled = shop.active && !shop.deleted
          var accessToShop = checkAccessToShop(shop.id)

          return {
            value: shop.id,
            label: shop.name,
            disabled: !shopEnabled || !accessToShop,
          }
        })
      : []

    this.setState({
      stores: shopList,
    })
  }

  onGridReady = (params) => {
    this.setState({
      gridApi: params.api,
    })
  }

  getMasterProducts = (term = '') => {
    const { gridApi } = this.state
    if (gridApi) {
      const dataSource = {
        getRows: (params) => {
          const page = params.endRow / perPage
          this.props
            .dispatch(searchAvailableMasterProducts((page - 1) * perPage, perPage, term, '', ''))
            .then((res) => {
              params.successCallback(res.values, res.total)
            })
            .catch(() => {
              params.successCallback([], 0)
            })
        },
      }

      gridApi.setDatasource(dataSource)
    }
  }

  processSubmit = () => {
    const { gridApi, selectedStore } = this.state
    if (gridApi.getSelectedNodes().length > 0 && selectedStore) {
      this.setState({
        hasError: {
          isVisible: false,
          message: '*Field are required',
        },
        selectedRows: gridApi.getSelectedNodes(),
        step: 2,
      })
    } else {
      this.setState({
        hasError: {
          isVisible: true,
          message: '*Field are required',
        },
      })
    }
  }

  sendAddLocation = () => {
    const { selectedStore, selectedRows } = this.state
    const params = {
      locations: selectedStore,
      masterProductIds: selectedRows.map((p) => p.data.id),
    }
    this.setState({
      hasError: {
        isVisible: false,
      },
    })

    this.props.dispatch(addLocationMasterProduct(params)).then(() => {
      this.props.closeModal(true)
    })
  }

  handleChangeStore = (values) => {
    const ShopIds = (values && values.length > 0 && values.map((s) => s.value)) || []
    this.setState({
      selectedStore: ShopIds,
    })
  }

  goBack = () => {
    this.setState({
      step: 1,
    })
  }

  onSearchMasterProducts = (event) => {
    const term = event.target.value
    const { gridApi } = this.state

    this.setState({ term })
    clearTimeout(timeout)
    timeout = setTimeout(() => {
      gridApi.setServerSideDatasource(this.getMasterProducts(term ? term : ''))
    }, 1500)
  }

  render() {
    const { open, shopReducer } = this.props
    const { stores, selectedStore, hasError, step, selectedRows, tableIsVisible, term } = this.state
    return (
      <Dialog open={open} className={'container-modal'}>
        <DialogTitle style={{ paddingBottom: 5 }}>
          Add to Location
          {step === 1 ? (
            <p className={'title-add-location'}>
              This allows you to add multiple Parent Products to a Location, only master products
              activated are listed.
            </p>
          ) : (
            <p className={'title-add-location'}>
              Confirm adding these products to{' '}
              <b>
                {selectedStore.length > 0 &&
                  selectedStore
                    .map((store) => {
                      return shopReducer.shopsList.values.find((s) => s.id === store).name + ' '
                    })
                    .join(', ')}
              </b>
            </p>
          )}
        </DialogTitle>
        <DialogContent className={'size-modal'}>
          {step === 1 && (
            <div className={'center-dropdown'}>
              <Input
                placeholder="Search Master Products"
                editMode
                material={false}
                style={{ width: '100%', height: '60%', marginBottom: '10px' }}
                startAdornment={
                  <InputAdornment position="start">
                    <SearchIcon />
                  </InputAdornment>
                }
                onChange={this.onSearchMasterProducts}
                value={term}
              />

              <EditableReactSelect
                editMode={true}
                material={false}
                multi={true}
                value={selectedStore}
                onChange={(value) => this.handleChangeStore(value)}
                options={
                  (stores &&
                    stores.map((item) => {
                      return { value: item.value, label: item.label, disabled: item.disabled }
                    })) ||
                  []
                }
              ></EditableReactSelect>
            </div>
          )}
          {tableIsVisible && (
            <div
              style={{
                display: step === 1 ? 'flex' : 'none',
                flexDirection: 'column',
                height: '90%',
                marginTop: '1em',
              }}
            >
              <div id="myGridLocation" className="ag-theme-alpine container-aggrid">
                <AgGridReact
                  columnDefs={[
                    {
                      field: 'name',
                      headerName: 'Product Name',
                      minWidth: 200,
                      checkboxSelection: true,
                    },
                    {
                      field: 'sku',
                      headerName: 'SKU',
                      minWidth: 150,
                    },
                  ]}
                  defaultColDef={{
                    flex: 1,
                    filter: false,
                    sortable: false,
                    resizable: false,
                  }}
                  onGridReady={this.onGridReady}
                  pagination={true}
                  rowModelType={'infinite'}
                  paginationPageSize={perPage}
                  cacheBlockSize={perPage}
                  maxBlocksInCache={perPage}
                  animateRows={true}
                  rowHeight={50}
                  rowSelection="multiple"
                />
              </div>
            </div>
          )}
          <Paper style={{ display: step === 2 ? 'inline-table' : 'none', width: '100%' }}>
            <Table style={{ width: '100%' }}>
              <TableHead style={{ display: 'block' }}>
                <TableRow>
                  <TableCell
                    style={{
                      minWidth: 200,
                      maxWidth: 200,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    Product Name
                  </TableCell>
                  <TableCell
                    style={{
                      minWidth: 150,
                      maxWidth: 150,
                      overflow: 'hidden',
                      textOverflow: 'ellipsis',
                    }}
                  >
                    SKU
                  </TableCell>
                </TableRow>
              </TableHead>
              <TableBody style={{ maxHeight: '50vh', overflowY: 'scroll', display: 'block' }}>
                {selectedRows.map((product, index) => (
                  <TableRow key={index}>
                    <TableCell
                      style={{
                        minWidth: 200,
                        maxWidth: 200,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {product.data.name}
                    </TableCell>
                    <TableCell
                      style={{
                        minWidth: 150,
                        maxWidth: 150,
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                      }}
                    >
                      {product.data.sku}
                    </TableCell>
                  </TableRow>
                ))}
              </TableBody>
            </Table>
          </Paper>
          {hasError.isVisible && (
            <span className={'center-aligned-child margin-top-xs text-error'}>
              {hasError.message}
            </span>
          )}
        </DialogContent>
        <DialogActions>
          <Button
            onClick={() => {
              this.props.closeModal(false)
            }}
            className="button-white-and-red"
          >
            <span className="button-text">Cancel</span>
          </Button>
          {step === 2 && (
            <Button onClick={this.goBack} className="button-white-and-red">
              <span className="button-text">Back</span>
            </Button>
          )}
          <Button
            className="button-blue-and-white"
            onClick={step === 1 ? this.processSubmit : this.sendAddLocation}
          >
            <span className="button-text">{step === 1 ? 'Submit' : 'Confirm'}</span>
          </Button>
        </DialogActions>
      </Dialog>
    )
  }
}

export const ModalAddLocationConnect = connect(({ dispatch, shopReducer }) => ({
  dispatch,
  shopReducer,
}))(ModalAddLocation)



// WEBPACK FOOTER //
// ./src/components/MasterCatalog/ModalAddLocation.js